export const getPaymentProviderIcon = (providerName) => {
  const iconTags = {
    visa: "visaNew",
    mastercard: "mastercardNew",
    paypal: "paypal"
  };
  
  return iconTags[providerName];
};
